/**
 * UserTypeBadge - Displays user type badge.
 *
 * Shows "Admin" badge for admin users, or "—" for regular users.
 */

export interface UserTypeBadgeProps {
  /**
   * Whether the user is an admin.
   */
  isAdmin: boolean;
}

export function UserTypeBadge({ isAdmin }: UserTypeBadgeProps) {
  if (isAdmin) {
    return (
      <span
        className="
          inline-flex items-center rounded-full bg-action-primary/10 py-0.5 text-xs font-medium text-action-primary
        "
      >
        Admin
      </span>
    );
  }

  return (
    <span
      className="
        text-text-muted
        dark:text-text-muted
      "
    >
      —
    </span>
  );
}
